import { EmailArrowRightIcon } from './EmailArrowRightIcon';

/**
 * author: Michael Richins
 * id 7C66176F-E1BF-4F04-A761-377F67916FDA
 * name email-arrow-right
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-arrow-right.svg
 * tags
 */
export const EmailSendIcon = EmailArrowRightIcon;
export default EmailSendIcon